import { useToastedMutation } from '../../../ReactQuery';
import { put } from '../../../redux/api';
import { nuc } from '../../../utils';

const ignoreDependency = async (parentLocator: string, dependencyLocator: string) => {
  await put(`/api/revisions/${nuc(parentLocator)}/dependencies/${nuc(dependencyLocator)}/ignore`, undefined);
};

/**
 * Hook for ignoring a dependency within a user project.
 */
export default function useIgnoreDependency(parentLocator: string) {
  return useToastedMutation({
    mutationFn: async (dependencyLocator: string) => ignoreDependency(parentLocator, dependencyLocator),
    successToastMessage: 'Dependency ignored successfully.',
    errorToastMessage: 'Failed to ignore dependency.',
  });
}
